import React, { useEffect, useState } from "react";
import { Row, Modal, Col } from "antd";
import { UserOutlined, TeamOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { Link, withRouter } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import Login from "../Login/Login";
import Singup from "../Login/Signup";
import { getParamCaptcha } from "../../../api/others";

/**
 *
 *Componente que muestra los links de Registro / Inicio de sesión en eñ portal público
 */
function SignIn(props) {

  const {
    history: { location: { pathname }, }, 
    /*paramCaptcha,*/
  } = props;

  const [paramCaptcha, setParamCaptcha] = useState(0); //Para ver que captcha mostrar

  const [visibleSession, setVisibleSession] = useState(false);
  const [visibleRegister, setVisibleRegister] = useState(false);
  const [visiblePerfil, setVisiblePerfil] = useState(false);
  const [visibleModalConfirm, setVisibleModalConfirm] = useState(false);
  const [tipoPerfil, setTipoPerfil] = useState();

  const {
    ciudadano: { ciudadano },
  } = useAuth();

  useEffect(() => {

    // PEL2024-2025. Se establece el valor del para paramCaptcha
    if ( paramCaptcha === undefined ) {

      getParamCaptcha.then((res) => {

        setParamCaptcha(res.data.paramCaptcha); //0 = captcha google, 1 = captcha react
  
      }).catch((error) => {  
        console.log("Error en servicio web ", error);
        setParamCaptcha(0)
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Funciones para mostrar el modal
  const showModalSession = () => {
    setVisibleSession(true);
    setVisibleRegister(false);
    setVisiblePerfil(false);
  };

  const showModalRegister = (perfil) => {
    setTipoPerfil(perfil);
    setVisibleRegister(true);
    setVisibleSession(false);
    setVisiblePerfil(false);
  };

  const showModalPerfil = () => {
    setVisiblePerfil(true);
    setVisibleRegister(false);
    setVisibleSession(false);
  };

  const handleOkSesion = (e) => {
    setVisibleSession(false);
  };

  const handleCancelSesion = (e) => {
    setVisibleSession(false);
  };

  const handleOk = (e) => {
    setVisibleRegister(false);
  };

  const handleCancel = (e) => {
    setVisibleRegister(false);
  };

  const handleOkConfirm = (e) => {
    showModalRegister(2)
    setVisibleModalConfirm(false);
  };

  const handleCancelConfirm = (e) => {
    setVisibleModalConfirm(false);
  };

  const handlePerfil = (e) => {
    setVisiblePerfil(false);
  };

  //console.log('paramCaptcha::::',paramCaptcha);

  return (
    <>

      {/* Modal de inicio de sesión */}
      <Modal open={visibleSession}
             onOk={handleOkSesion}
             onCancel={handleCancelSesion}
             footer={null}
             className="modalLoginRegistro" >

        <h1 style={{ textAlign: "center" }}>Inicia Sesión</h1>

        <Login visibleSession={visibleSession} 
               paramCaptcha={paramCaptcha} />

          {" "}
        <br/>

        <Row style={{ marginBottom: "10px" }}>
          <Link to="/portal/recovery">¿Olvidaste tu contraseña?</Link>
        </Row>

        <p>
          <strong>¿Eres nuevo?</strong><br/>
          <Link to={pathname} onClick={showModalPerfil}>
            Regístrate
          </Link>
          para iniciar con tu solicitud.
        </p>

      </Modal>

      {/* Modal de registo de cuenta */}
      <Modal open={visibleRegister}
             onOk={handleOk}
             onCancel={handleCancel}
             footer={null}
             className="modalLoginRegistro" >

        <center>
          {tipoPerfil === 1 ? (
            <h1>Registro de ciudadanía</h1>
          ) : (
            <h1>Registro de organización</h1>
          )}
        </center>

        <Singup setVisibleRegister={setVisibleRegister}
                visibleRegister={visibleRegister}
                perfilCuenta={tipoPerfil} />

        <hr />

        <p>
          ¿Ya tienes una cuenta? &nbsp;
          <Link to={pathname} onClick={showModalSession}>
            Inicia Sesión
          </Link>
        </p>

      </Modal>

      {/* Modal de selección de perfil */}
      <Modal open={visiblePerfil}
             onOk={handlePerfil}
             onCancel={handlePerfil}
             footer={null}
             className="modalLoginRegistro" >

        <Row>
          <Col span={24}>
            <h1 style={{textAlign: "center"}}>Selecciona tu perfil</h1>
          </Col>
        </Row>

        <Row gutter={[24,24]}>
          <Col span={24}>
            <Link to={pathname} className="linkPerfil" onClick={() => showModalRegister(1)}>
              <div className="card-menu-perfil">

                <table style={{fontSize: "14px"}}>
                  <tbody>
                  <tr>
                    <td rowSpan={3} style={{fontSize: "50px", color:"#DB2491"}}><UserOutlined /></td>
                  </tr>
                  <tr>
                    <td><strong>Ciudadanía</strong></td>
                  </tr>
                  <tr>
                    <td>Ciudadanos/as mexicanos que desean observar los actos de preparación y desarrollo del Proceso Electoral,
                      así como los actos de la jornada electoral.</td>
                  </tr>
                  </tbody>
                </table>

              </div>
            </Link>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Link to={pathname} className="linkPerfil" onClick={() => setVisibleModalConfirm(true)/*showModalRegister(2)*/}>
              <div className="card-menu-perfil">

                <table style={{fontSize: "14px"}}>
                  <tbody>
                  <tr>
                    <td rowSpan={3} style={{fontSize: "50px", color:"#DB2491"}}><TeamOutlined /></td>
                  </tr>
                  <tr>
                    <td><strong>Organización</strong></td>
                  </tr>
                  <tr>
                    <td>Organizaciones que desean registrarse para acreditarse como Organización Electoral (OE) y participar 
                      en el proceso electoral.</td>
                  </tr>
                  </tbody>
                </table>

              </div>
            </Link>
          </Col>
        </Row>
      </Modal>
      {/**Modal de confirmación antes del registro de organización */}
      <Modal open={visibleModalConfirm} onOk={handleOkConfirm} onCancel={handleCancelConfirm}>
        <Row>
          <Col span={2} style={{fontSize: "30px", color:"#DB2491"}}><InfoCircleOutlined/></Col>
          <Col span={20} style={{textAlign: "center", fontWeight:"bold"}}><p>Estás por registrarte como Organización,<br/> ¿Deseas continuar?</p></Col>
        </Row>
      </Modal>

      {!ciudadano && (
        <div className="login-registro">
          <Row>
            <Col span={12}>
              <div className="registrate">

                <Link to={pathname}
                      type="link"
                      onClick={showModalPerfil}
                      style={{ textDecoration: "underline" }} >
                  Regístrate
                </Link>{" "}

                <span>para iniciar tu solicitud</span>

              </div>
            </Col>
            <Col span={12}>
              <div className="loginCiudadano">

                <Link to={pathname} onClick={showModalSession}>
                  <UserOutlined /> Inicia sesión
                </Link>

              </div>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
}
export default withRouter(SignIn);
